import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RsvpPage } from './components/wedding/rsvp/RsvpPage';
import { GuestListPage } from './components/wedding/guests/GuestListPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/:domain/invites" element={<RsvpPage />} />
        <Route path="/:domain/guests" element={<GuestListPage />} />
        <Route path="/:domain" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
